import { useContext } from "react";
import DashboardContext from "../../Context";
import { Redirect } from "react-router-dom";
import Layout from "../../components/layout/index"; 
import "./style.css"

const HomePage = () => {
  const { islogin } = useContext(DashboardContext);

  return (
    <>
      {islogin ? (
        <Layout>
          <div className="landing-page-container">
            <span>به سامانه وب سرویک خوش آمدید</span>
          </div>
        </Layout>
      ) : (
        <Redirect to={{ pathname: "/login", state: { status: 302 } }} />
      )}
    </>
  );
};

export default HomePage;
